import { client } from "../client";
import { Paginated, PaginatedFilter } from "../types/axios.types";
import { Earmold, Variant } from "../types/earmold.types";

export const fetchEarmoldsPaginated = async (
	page?: number,
	size?: number,
	search?: string,
	filters?: PaginatedFilter,
	sortBy?: string[],
) => {
	const params = new URLSearchParams();
	// Pagination
	params.append("page", page ? page.toString() : "1");
	params.append("size", size ? size.toString() : "50");
	// Search
	if (search) {
		params.append("search", search);
	}
	// Sort
	if (sortBy) {
		sortBy.forEach((key) => params.append("sort", key));
	}
	// Filters
	if (filters) {
		Object.keys(filters).forEach((key: string) => {
			// Blacklist some keys
			if (
				["page", "size", "search", "sort"].includes(key) ||
				filters[key] === ""
			) {
				return;
			}
			params.append(
				key,
				Array.isArray(filters[key]) ? filters[key].join(",") : filters[key],
			);
		});
	}
	// Query
	const response = await client.get<Paginated<Earmold[]>>(`earmolds/`, {
		params,
	});
	return response.data;
};

export const fetchEarmoldVariantsPaginated = async (
	id: number | string | undefined,
	page?: number,
	size?: number,
	search?: string,
	filters?: PaginatedFilter,
	sortBy?: string[],
) => {
	if (id == undefined) {
		return null;
	}
	const params = new URLSearchParams();
	// Pagination
	params.append("page", page ? page.toString() : "1");
	params.append("size", size ? size.toString() : "50");
	// Search
	if (search) {
		params.append("search", search);
	}
	// Sort
	if (sortBy) {
		sortBy.forEach((key) => params.append("sort", key));
	}
	// Filters
	if (filters) {
		Object.keys(filters).forEach((key: string) => {
			// Blacklist some keys
			if (
				["page", "size", "search", "sort"].includes(key) ||
				filters[key] === ""
			) {
				return;
			}
			params.append(
				key,
				Array.isArray(filters[key]) ? filters[key].join(",") : filters[key],
			);
		});
	}
	// Query
	const response = await client.get<Paginated<Variant[]>>(
		`earmolds/${id}/variants`,
		{
			params,
		},
	);
	return response.data;
};

export const fetchEarmoldVariants = async (id: number | string | undefined) => {
	if (id == undefined) {
		return null;
	}
	const params = new URLSearchParams();
	params.append("all", "t");
	const response = await client.get<Variant[]>(`earmolds/${id}/variants`, {
		params,
	});
	return response.data;
};

export const fetchEarmold = async (id: number | string | undefined) => {
	if (id == undefined) {
		return null;
	}
	// Query
	const response = await client.get<Earmold>(`earmolds/${id}`);
	return response.data;
};
